import * as React from 'react';
import { useSelector } from 'react-redux';
import { getBannersByRegionId } from '../../selectors';
import { Carousel as CarouselComponent } from '../../components/Carousel';

export function Carousel() {
  const bannersByRegionId = useSelector(getBannersByRegionId);

  return <CarouselComponent banners={bannersByRegionId} testId="MainCarousel" />;
}
